import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { DimensionValueScoreSelectable } from 'src/app/shared/complexity-mgnt/dimension-value-score-selectable';
import { ComplexityMngtService } from '../../shared/complexity-mgnt/complexity-mngt.service';

@Component({
  templateUrl: './top-vals.component.html',
  styleUrls: ['../general.scss', './complexity-mgnt.component.scss']
})
export class TopValsComponent implements OnInit {
    TopValsSort: typeof TopValsSort = TopValsSort;   //hack for enum to be available in the template
    public loading: boolean = true;
    public projectId: string;
    private dimIndex: number;
    public columnName: string;
    public values: DimensionValueScoreSelectable[] = [];

    public sortAsc: boolean = true;
    public sortBy: TopValsSort = TopValsSort.Relevance;

    constructor(private activatedRoute: ActivatedRoute, private router: Router, 
        private complexityMngtService: ComplexityMngtService) { }

    ngOnInit(): void {
        this.loading = true;
        this.activatedRoute.queryParams.subscribe((queryParams: any) => {
            let projectId = queryParams.projectId;
            let dimIndex = queryParams.dimIndex;
            if (projectId) {
                this.projectId = projectId;
                this.dimIndex = dimIndex;
                this.complexityMngtService.getTopVals(projectId, dimIndex)
                .then(resp => {
                    if (!resp.selectedValues || !resp.selectedValues.length) {
                        this.gotoComplexityPage();
                    }
                    this.columnName = resp.columnName;
                    this.values = resp.selectedValues;
                    this.loading = false;
                }).catch(err => {
                    this.gotoComplexityPage();
                });
            }
        });
    }

    public async save () {
        if (this.loading) {
            return;
        }
        this.loading = true;
        try {
            await this.complexityMngtService.saveTopVals(this.projectId, this.columnName, this.values.filter(v => v.selected).map(v => v.value));
            this.gotoComplexityPage();
        } finally {
            this.loading = false;
        };
    }

    public sort(sortBy: TopValsSort) {
        if (this.sortBy == sortBy) {
            this.sortAsc = !this.sortAsc;
        } else {
            this.sortBy = sortBy;
            switch (sortBy) {
                case TopValsSort.Relevance:
                    case TopValsSort.Value:
                    this.sortAsc = true;
                    break;
                case TopValsSort.Complexity:
                case TopValsSort.Outcomes:
                case TopValsSort.Variance:
                    this.sortAsc = false;
                    break;

            }
        }
        let sorter : (a: DimensionValueScoreSelectable, b: DimensionValueScoreSelectable) => number;
        switch (sortBy) {
            case TopValsSort.Relevance:
                if (this.sortAsc) {
                    sorter = (a, b) => a.relevance - b.relevance;
                } else {
                    sorter = (a, b) => b.relevance - a.relevance;
                }
                break;
            case TopValsSort.Value:
                let sorterLocal = (a, b) => {
                    var nameA = a.value.toLowerCase(), nameB = b.value.toLowerCase();
                    if (nameA < nameB) {
                        return -1;
                    }
                    if (nameA > nameB) {
                        return 1;
                    }
                    return 0;
                }
                if (this.sortAsc) {
                    sorter = (a, b) => sorterLocal(a, b);
                } else {
                    sorter = (a, b) => -sorterLocal(a, b);
                }
                break;
            case TopValsSort.Complexity:
                if (this.sortAsc) {
                    sorter = (a, b) => a.complexityScore - b.complexityScore;
                } else {
                    sorter = (a, b) => b.complexityScore - a.complexityScore;
                }
                break;
            case TopValsSort.Outcomes:
                if (this.sortAsc) {
                    sorter = (a, b) => a.outcomesScore - b.outcomesScore;
                } else {
                    sorter = (a, b) => b.outcomesScore - a.outcomesScore;
                }
                break;
            case TopValsSort.Variance:
                if (this.sortAsc) {
                    sorter = (a, b) => a.varianceScore - b.varianceScore;
                } else {
                    sorter = (a, b) => b.varianceScore - a.varianceScore;
                }
                break;
        }
        this.values = this.values.sort(sorter);
    }

    private gotoComplexityPage() {
        this.router.navigateByUrl('/complexity-mgnt?projectId=' + this.projectId);
    }
}

export enum TopValsSort {
    Relevance,
    Value,
    Complexity,
    Outcomes,
    Variance,
}